import { Component } from '@angular/core';
import { CurrencyService } from './public/core/services/currency-service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html'
})
export class AppComponent {
	title = 'D-IOTOV ART магазин, картини, стенописи';


}
